import EmployeeConfirmation from "../../employee-confirmation";
import EmployeeConfirmationCreate from "../../employee-confirmation/pages/employee-confirmation-create";
import EmployeeConfirmationDetail from "../../employee-confirmation/pages/employee-confirmation-detail";

export const employeeConfirmationRoutes = {
  employeeConfirmation: {
    isAdmin: false,
    title: "3. Xác nhận nhân viên",
    path: "/procedure/employee-confirmation",
    parentId: "procedure",
    component: EmployeeConfirmation,
  },
  employeeConfirmationCreate: {
    isAdmin: false,
    path: "/procedure/employee-confirmation/create",
    parentId: "procedure",
    component: EmployeeConfirmationCreate,
  },
  employeeConfirmationDetail: {
    isAdmin: false,
    path: "/procedure/employee-confirmation/:id",
    parentId: "procedure",
    component: EmployeeConfirmationDetail,
  },
};
